export enum IfGateAndOr {
	And = '&&',
	Or = '||',
}
